export const inputMaskStyle = {
  padding: '14px 24px 14px 14px',
  borderRadius: '6px',
  height: '48px',
  fontSize: '16px',
  color: '#222222',
  border: '1px solid #A1A9B8',
  background: '#FAFAFA',
};
